import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'moorl-grid-layout-nine',
    label: 'sw-cms.blocks.moorl-grid-layout.nine',
    category: 'moorl-grid-layout',
    component: 'sw-cms-block-moorl-grid-layout-nine',
    previewComponent: 'sw-cms-preview-block-moorl-grid-layout-nine',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '0',
        marginLeft: '0',
        marginRight: '0',
        sizingMode: 'boxed',
    },
    slots: {
        'slot-a': 'moorl-replacer',
        'slot-b': 'moorl-replacer',
        'slot-c': 'moorl-replacer',
        'slot-d': 'moorl-replacer',
        'slot-e': 'moorl-replacer',
    },
});
